import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Font,
  Code,
  CodeBlock,
  Superscript,
  Subscript,
  Heading,
  Strikethrough,
  BlockQuote,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  LinkImage,
  Link,
  ImageUpload,
  ImageInsert,
  Base64UploadAdapter,
  Alignment,
} from "ckeditor5";

import "ckeditor5/ckeditor5.css";
import { useRef } from "react";

export const EditorCK = ({ value, onChange }) => {
  const editorRef = useRef(null);
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onReady={(editor) => {
        editorRef.current = editor;
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
      config={{
        licenseKey: "GPL",
        plugins: [
          Essentials,
          Paragraph,
          Bold,
          Italic,
          Font,
          Code,
          CodeBlock,
          Superscript,
          Subscript,
          Heading,
          Strikethrough,
          BlockQuote,
          Image,
          ImageCaption,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          Link,
          LinkImage,
          ImageUpload,
          ImageInsert,
          Base64UploadAdapter,
          Alignment,
        ],
        toolbar: [
          "undo",
          "redo",
          "|",
          "heading",
          "|",
          "fontfamily",
          "fontsize",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "alignment",
          "bold",
          "italic",
          "strikethrough",
          "subscript",
          "superscript",
          "code",
          "|",
          "link",
          "insertImage",
          "uploadImage",
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "imageTextAlternative",
          "blockQuote",
          "codeBlock",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "outdent",
          "indent",
        ],
      }}
    />
  );
};
